module.exports = __webpack_public_path__ + "static/media/home.ac5e0d09.jpg";